import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static ACTIVE_TAB_CLASSES = ["border-green-mga", "bg-green-50", "text-green-900", "font-semibold", "shadow-sm"]
  static INACTIVE_TAB_CLASSES = ["border-gray-300", "bg-white", "text-gray-700", "font-medium"]

  connect() {
    if (this.hasTabTarget) {
      this.show(0)
    }
  }

  select(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    if (!Number.isNaN(index)) {
      this.show(index)
    }
  }

  show(index) {
    this.tabTargets.forEach((tab, i) => {
      const active = i === index
      tab.setAttribute("aria-selected", active ? "true" : "false")

      // Ensure only one visual state is applied at a time.
      tab.classList.remove(...this.constructor.ACTIVE_TAB_CLASSES, ...this.constructor.INACTIVE_TAB_CLASSES)
      tab.classList.add(...(active ? this.constructor.ACTIVE_TAB_CLASSES : this.constructor.INACTIVE_TAB_CLASSES))
    })
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
